import PropTypes from "prop-types";
import { socialMediaPlatforms } from "./static";

const SocialMediaShareButtons = ({ propertyUrl }) => (
  <div className="grid grid-cols-2 gap-5">
    {socialMediaPlatforms?.map(({ name, icon, url, bgColor }, index) => (
      <a
        key={index}
        href={url(propertyUrl)}
        target="_blank"
        rel="noopener noreferrer"
        className="text-white px-6 py-2 rounded-xl flex items-center gap-2 font-medium hover:text-white"
        style={{ background: bgColor }}>
        {icon}
        <span>{name}</span>
      </a>
    ))}
  </div>
);

const { string } = PropTypes;

SocialMediaShareButtons.propTypes = {
  propertyUrl: string
};

export default SocialMediaShareButtons;
